<div class="icon done">
  <i class="fa fa-check"></i>
</div>
<h3 i18n="Connection wizard last message when the application is connected@@connectionWizardApplicationConnected">Application is connected</h3>

<div *ngIf="connectionInfo" class="connection-info">
  <div class="connection-info-row">
    <span class="connection-info-label" i18n="Auth method label@@connectionWizardAuthMethod">Auth method</span>
    <span class="connection-info-value">{{ connectionInfo.authType === 'client_credentials' ? 'Client credentials' : 'User / Password' }}</span>
  </div>
  <div class="connection-info-row" *ngIf="connectionInfo.applicationId">
    <span class="connection-info-label" i18n="Application ID label@@connectionWizardApplicationId">Application ID</span>
    <span class="connection-info-value">{{ connectionInfo.applicationId }}</span>
  </div>
  <div class="connection-info-row" *ngIf="connectionInfo.authType !== 'client_credentials' && connectionInfo.user">
    <span class="connection-info-label" i18n="PBI user label@@connectionWizardUser">User</span>
    <span class="connection-info-value">{{ connectionInfo.user }}</span>
  </div>
  <div class="connection-info-row" *ngIf="connectionInfo.authType === 'client_credentials' && connectionInfo.tenantId">
    <span class="connection-info-label" i18n="Tenant ID label@@connectionWizardTenantId">Tenant ID</span>
    <span class="connection-info-value">{{ connectionInfo.tenantId }}</span>
  </div>
</div>

<div *ngIf="testResult" class="alert mt-2" [class.alert-success]="testResult.success" [class.alert-danger]="!testResult.success">
  {{ testResult.message }}
</div>

<div class="step-d-actions">
  <button class="btn btn-outline-secondary" (click)="testConnection.emit()" i18n="Test connection button in step d@@connectionWizardTestConnection">
    <i class="fa fa-plug"></i> Test Connection
  </button>
  <button class="btn btn-outline-info" (click)="editConnection.emit()" i18n="Edit connection button in step d@@connectionWizardEditConnection">
    <i class="fa fa-pencil"></i> Edit Connection
  </button>
</div>
